<template>
  <div>
    <b-row>
      <b-col cols="9" class="mb-2"></b-col>

      <b-col class="mb-2">
        <b-button block variant="success" @click="addUser()" :disabled="!CREATE">Crear</b-button>
      </b-col>
    </b-row>

    <b-row class="mb-0">
      <b-col sm="4">
        <b-form-group>
          <label for="txtIdentification" class="mb-0">NIT usuario</label>
          <b-form-input type="text" id="txtIdentification" v-model="identification_filter" @blur="getUsers()"></b-form-input>
        </b-form-group>
      </b-col>

      <b-col sm="4">
        <b-form-group>
          <label for="cmbRolAux" class="mb-0">Rol Sistema</label>
          <b-form-select v-model="role_id_filter" class="mb-3" id="cmbRolAux" @change="getUsers()">
            <template slot="first">
              <option :value="null" >-- Todos --</option>
            </template>
            <option v-for="item in lstRole" :key="item.id" :value="item.id">{{ item.name }}</option>
          </b-form-select>
        </b-form-group>
      </b-col>

      <b-col sm="4">
        <b-form-group>
          <label for="cmbEstadoUserAux" class="mb-0">Estado</label>
          <b-form-select id="cmbEstadoUserAux" v-model="status_filter" @change="getUsers()">
            <template slot="first">
              <option :value="null" >-- Todos--</option>
            </template>
            <option value="P">Por activar</option>
            <option value="A">Activo</option>
            <option value="I">Inactivo</option>
          </b-form-select>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="mt-0">
      <b-col cols="12" xl="12">
        <transition name="slide">
          <b-card :header="caption">

            <div v-if="isAdmin">
              <div class="row" v-if="selectItems.length > 0">
                <div class="col-sm-4">
                  <b-form-group>
                    <b-form-select id="cmbEstado" v-model="status" @change="actualizarEstado()">
                      <template slot="first">
                        <option :value="null" disabled>-- Actualizar Estado--</option>
                      </template>
                      <option value="P">Por activar</option>
                      <option value="A">Activo</option>
                      <option value="I">Inactivo</option>
                    </b-form-select>
                  </b-form-group>
                </div>
                <div class="col-sm-2">
                  <b-button
                    variant="danger"
                    class="float-right col-sm-12"
                    @click="eliminarSeleccionados()"
                  >Eliminar</b-button>
                </div>
              </div>
            </div>

            <b-table
              :hover="hover"
              :striped="striped"
              :bordered="bordered"
              :small="small"
              :fixed="fixed"
              responsive="sm"
              :items="items"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
            >
              <template slot="HEAD_selected" v-if="isAdmin">
                <input type="checkbox" @click.stop v-model="selectAll" @change="toggleSelectAll()" />
              </template>

              <template slot="selected" slot-scope="data" v-if="isAdmin">
                <input type="checkbox" v-model="data.item.selected" @change="selectRow(data.item)" />
              </template>

              <template slot="name" slot-scope="data">
                <span>{{data.item.user_type == 48 ? data.item.name +" "+ data.item.last_name : data.item.name}}</span>
              </template>

              <template slot="status" slot-scope="data">
                <b-badge :variant="getBadge(data.item.status)">{{getTextStatus(data.item.status)}}</b-badge>
              </template>

              <template slot="actions" slot-scope="data">
                <!-- <template v-slot:cell(actions)="data"> -->
                <b-button
                  size="sm"
                  variant="primary"
                  class="mr-1 btn-custom-size"
                  @click="view(data.item.id)"
                  title="Ver"
                  :disabled="!READ"
                >
                  <i class="fa fa-eye"></i>
                </b-button>

                <b-button
                  size="sm"
                  variant="success"
                  class="mr-1 btn-custom-size"
                  @click="editUser(data.item.id)"
                  title="Editar"
                  :disabled="!UPDATE"
                >
                  <i class="fa fa-edit"></i>
                </b-button>
                <b-button
                  size="sm"
                  variant="danger"
                  class="btn-custom-size"
                  @click="deleteUser(data.item.id)"
                  title="Eliminar"
                  :disabled="!DELETE"
                >
                  <i class="fa fa-trash"></i>
                </b-button>
              </template>
            </b-table>
            <hr />
            <div class="row">
              <div
                class="col-sm-4"
              >Mostrando {{getRowCount(items) > (perPage * currentPage) ? perPage * currentPage : getRowCount(items)}} de {{getRowCount(items)}} registros</div>
              <div class="col-sm-8">
                <nav>
                  <b-pagination
                    size="sm"
                    align="right"
                    :total-rows="getRowCount(items)"
                    :per-page="perPage"
                    v-model="currentPage"
                    prev-text="Anterior"
                    next-text="Siguiente"
                    :limit="10"
                  />
                </nav>
              </div>
            </div>
          </b-card>
        </transition>
      </b-col>
    </b-row>

    <!-- MODAL PARA LOS USUARIOS -->
    <div class="modal fade" id="dlgUsuario">
      <div class="modal-dialog modal-dialog-centered modal-success modal-lg">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header">
            <h4 class="modal-title">USUARIO</h4>
            <button type="button" class="close" @click="close()">&times;</button>
          </div>

          <!-- Modal body -->
          <div class="modal-body">
            <form @submit.prevent="save" method="post" enctype="multipart/form-data">
              <b-row>
                <b-col class="center-block">
                  <b-row>
                    <b-col sm="12" v-if="errores.length">
                      <b-alert show variant="warning">
                        <b>ADVERTENCIAS:</b>
                        <li class="ml-2" v-for="(error, index) in errores" :key="index">{{ error }}</li>
                      </b-alert>
                    </b-col>
                  </b-row>
                  <div class="mt-2">
                    <img v-if="image" :src="image" class="rounded mx-auto d-block img-avatar-sm" />

                    <img
                      v-else
                      src="img/avatars/avatar-2-64.png"
                      class="rounded mx-auto d-block img-avatar-sm"
                    />
                  </div>

                  <b-row>
                    <b-col sm="6">
                      <b-form-group>
                        <label for="cmbTipo">Tipo usuario</label>
                        <b-form-select v-model="user.user_type" id="cmbTipo" :disabled="disabled">
                          <option
                            v-for="item in lstTypeUser"
                            :key="item.id"
                            :value="item.id"
                          >{{ item.name }}</option>
                        </b-form-select>
                      </b-form-group>
                    </b-col>

                    <b-col sm="6">
                      <label>Foto de perfil</label>
                      <b-form-file
                        :browse-text="'Buscar'"
                        v-model="file"
                        :state="Boolean(file)"
                        v-on:change="onImageChange"
                        placeholder="Elija un archivo o suéltelo aquí ..."
                        drop-placeholder="Suelta el archivo aquí ..."
                        :disabled="disabled"
                      ></b-form-file>
                    </b-col>
                  </b-row>

                  <div role="tablist" class="custom-accordion">
                    <b-card no-body class="mb-1">
                      <b-card-header header-tag="header" class="p-1" role="tab">
                        <b-button
                          class="text-left"
                          block
                          href="#"
                          v-b-toggle.accordion-staff
                          variant="primary"
                        >
                          <span v-if="user.user_type == 48">Información Funcionario</span>
                          <span v-else>Información cliente</span>
                        </b-button>
                      </b-card-header>
                      <b-collapse
                        id="accordion-staff"
                        visible
                        accordion="my-accordion"
                        role="tabpanel"
                      >
                        <b-card-body v-if="user.user_type == 48">
                          <b-row>
                            <b-col sm="3">
                              <b-form-group>
                                <label for="cmbTipoStaff">Tipo</label>
                                <b-form-select
                                  v-model="user.type"
                                  id="cmbTipoStaff"
                                  :disabled="disabled"
                                >
                                  <template slot="first">
                                    <option
                                      :value="null"
                                      disabled
                                    >-- Por favor seleccione una opción --</option>
                                  </template>
                                  <option
                                    v-for="item in lstType"
                                    :key="item.id"
                                    :value="item.id"
                                  >{{ item.name }}</option>
                                </b-form-select>
                              </b-form-group>
                            </b-col>

                            <b-col sm="3">
                              <b-form-group>
                                <label for="cmbTipoDocumento">Tipo documento</label>
                                <b-form-select
                                  v-model="user.identification_type"
                                  id="cmbTipoDocumento"
                                  :disabled="disabled"
                                >
                                  <template slot="first">
                                    <option
                                      :value="null"
                                      disabled
                                    >-- Por favor seleccione una opción --</option>
                                  </template>
                                  <option
                                    v-for="item in lstTipoDocumento"
                                    :key="item.id"
                                    :value="item.id"
                                  >{{ item.name }}</option>
                                </b-form-select>
                              </b-form-group>
                            </b-col>

                            <b-col sm="6">
                              <b-form-group>
                                <label for="txtIdentificacion">Identificación</label>
                                <b-form-input
                                  type="text"
                                  id="txtIdentificacion"
                                  v-model="user.identification"
                                  :disabled="disabled"
                                ></b-form-input>
                              </b-form-group>
                            </b-col>
                          </b-row>

                          <b-row>
                            <b-col sm="6">
                              <b-form-group>
                                <label for="txtNombre">Nombre(s)</label>
                                <b-form-input
                                  type="text"
                                  id="txtNombre"
                                  v-model="user.name"
                                  :disabled="disabled"
                                ></b-form-input>
                              </b-form-group>
                            </b-col>

                            <b-col sm="6">
                              <b-form-group>
                                <label for="txtApellido">Apellido(s)</label>
                                <b-form-input
                                  type="text"
                                  id="txtApellido"
                                  v-model="user.last_name"
                                  :disabled="disabled"
                                ></b-form-input>
                              </b-form-group>
                            </b-col>
                          </b-row>

                          <b-row>
                            <b-col sm="3">
                              <b-form-group>
                                <label for="txtTelefono">Teléfono</label>
                                <b-form-input
                                  type="text"
                                  id="txtTelefono"
                                  v-model="user.phone"
                                  :disabled="disabled"
                                ></b-form-input>
                              </b-form-group>
                            </b-col>
                            <b-col sm="3">
                              <b-form-group>
                                <label for="txtCelular">Celular</label>
                                <b-form-input
                                  type="text"
                                  id="txtCelular"
                                  v-model="user.mobile"
                                  :disabled="disabled"
                                ></b-form-input>
                              </b-form-group>
                            </b-col>

                            <b-col sm="6">
                              <b-form-group>
                                <label for="txtDireccion">Dirección</label>
                                <b-form-input
                                  type="text"
                                  id="txtDireccion"
                                  v-model="user.address"
                                  :disabled="disabled"
                                ></b-form-input>
                              </b-form-group>
                            </b-col>
                          </b-row>

                          <b-row>
                            <b-col sm="8">
                              <b-form-group
                                validated
                                label="E-mail"
                                label-for="txtEmailPersonal"
                                description="Usuario con el que ingresa al sistema."
                              >
                                <b-form-input
                                  id="txtEmailPersonal"
                                  type="email"
                                  placeholder="ejemplo@email.com"
                                  required
                                  v-model="user.personal_mail"
                                  :disabled="disabled"
                                ></b-form-input>
                              </b-form-group>
                            </b-col>

                            <b-col sm="4">
                              <b-form-group>
                                <label for="cmbEstadoUser">Estado</label>
                                <b-form-select
                                  id="cmbEstadoUser"
                                  v-model="user.status"
                                  :disabled="disabled"
                                >
                                  <template slot="first">
                                    <option :value="null" disabled>-- Estado--</option>
                                  </template>
                                  <option value="P">Por activar</option>
                                  <option value="A">Activo</option>
                                  <option value="I">Inactivo</option>
                                </b-form-select>
                              </b-form-group>
                            </b-col>
                          </b-row>
                        </b-card-body>

                        <b-card-body v-else>
                          <b-row>
                            <b-col sm="12">
                              <b-form-group>
                                <label for="txtNombreUser">Nombre</label>
                                <b-form-input
                                  type="text"
                                  id="txtNombreUser"
                                  v-model="user.name"
                                  :disabled="disabled"
                                ></b-form-input>
                              </b-form-group>
                            </b-col>
                          </b-row>

                          <b-row>
                            <b-col sm="8">
                              <b-form-group
                                validated
                                label="E-mail"
                                label-for="txtEmailPersonalUser"
                                description="Usuario con el que ingresa al sistema."
                              >
                                <b-form-input
                                  id="txtEmailPersonalUser"
                                  type="email"
                                  placeholder="ejemplo@email.com"
                                  required
                                  v-model="user.personal_mail"
                                  :disabled="disabled"
                                ></b-form-input>
                              </b-form-group>
                            </b-col>

                            <b-col sm="4">
                              <b-form-group>
                                <label for="cmbEstadoUser_">Estado</label>
                                <b-form-select
                                  id="cmbEstadoUser_"
                                  v-model="user.status"
                                  :disabled="disabled"
                                >
                                  <template slot="first">
                                    <option :value="null" disabled>-- Estado--</option>
                                  </template>
                                  <option value="P">Por activar</option>
                                  <option value="A">Activo</option>
                                  <option value="I">Inactivo</option>
                                </b-form-select>
                              </b-form-group>
                            </b-col>
                          </b-row>

                          <b-form-group>
                            <hr />
                            <h5>Buscar cuenta</h5>
                          </b-form-group>

                          <b-row>
                            <b-col sm="6">
                              <b-form-group>
                                <label for="cmbTipoDocumentoCustomer">Tipo documento</label>
                                <b-form-select
                                  v-model="user.customer_identification_type"
                                  id="cmbTipoDocumentoCustomer"
                                  @change="getCustomer()"
                                  :disabled="disabled"
                                >
                                  <template slot="first">
                                    <option
                                      :value="null"
                                      disabled
                                    >-- Por favor seleccione una opción --</option>
                                  </template>
                                  <option
                                    v-for="item in lstTipoDocumento"
                                    :key="item.id"
                                    :value="item.id"
                                  >{{ item.name }}</option>
                                </b-form-select>
                              </b-form-group>
                            </b-col>

                            <b-col sm="6">
                              <b-form-group>
                                <label for="txtIdentificacionCustomer">Identificación</label>
                                <b-form-input
                                  type="text"
                                  id="txtIdentificacionCustomer"
                                  v-model="user.customer_identification"
                                  @blur="getCustomer()"
                                  :disabled="disabled"
                                ></b-form-input>
                              </b-form-group>
                            </b-col>
                          </b-row>

                          <b-row>
                            <b-col sm="12">
                              <b-form-group>
                                <label for="txtNombreCustomer">Empresa(cuenta)</label>
                                <b-form-input
                                  :disabled="true"
                                  type="text"
                                  id="txtNombreCustomer"
                                  v-model="user.customer_name"
                                ></b-form-input>
                              </b-form-group>
                            </b-col>
                          </b-row>
                        </b-card-body>
                      </b-collapse>
                    </b-card>

                    <b-card no-body class="mb-1">
                      <b-card-header header-tag="header" class="p-1" role="tab">
                        <b-button
                          class="text-left"
                          block
                          href="#"
                          v-b-toggle.accordion-user
                          variant="primary"
                        >Información de acceso</b-button>
                      </b-card-header>
                      <b-collapse id="accordion-user" accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                          <b-row v-if="disabled==false">
                            <b-col sm="6">
                              <b-form-group>
                                <label for="txtContrasena">Contraseña</label>
                                <b-form-input
                                  type="password"
                                  id="txtContrasena"
                                  v-model="user.password"
                                  autocomplete="new-password"
                                ></b-form-input>
                              </b-form-group>
                            </b-col>

                            <b-col sm="6">
                              <b-form-group>
                                <label for="txtContrasenaConfirmar">Confirmar Contraseña</label>
                                <b-form-input
                                  type="password"
                                  id="txtContrasenaConfirmar"
                                  v-model="passwordConfirm"
                                  autocomplete="new-password"
                                ></b-form-input>
                              </b-form-group>
                            </b-col>
                          </b-row>

                          <b-row>
                            <b-col>
                              <b-form-group>
                                <label for="cmbRol">Rol Sistema</label>
                                <b-form-select
                                  v-model="user.role_id"
                                  class="mb-3"
                                  id="cmbRol"
                                  :disabled="disabled"
                                >
                                  <template slot="first">
                                    <option
                                      :value="null"
                                      disabled
                                    >-- Por favor seleccione una opción --</option>
                                  </template>

                                  <option
                                    v-for="item in lstRole"
                                    :key="item.id"
                                    :value="item.id"
                                  >{{ item.name }}</option>
                                </b-form-select>
                              </b-form-group>
                            </b-col>
                            <b-col sm="6" v-if="user.user_type == 48">
                              <b-form-group>
                                <label for="cmbSucursal">Sucursal</label>
                                <b-form-select
                                  v-model="user.branch_office_id"
                                  class="mb-3"
                                  id="cmbSucursal"
                                  :disabled="disabled"
                                >
                                  <template slot="first">
                                    <option
                                      :value="null"
                                      disabled
                                    >-- Por favor seleccione una opción --</option>
                                  </template>

                                  <option
                                    v-for="item in lstBranchOffices"
                                    :key="item.id"
                                    :value="item.id"
                                  >{{ item.name }}</option>
                                </b-form-select>
                              </b-form-group>
                            </b-col>
                          </b-row>

                          <b-row v-if="user.user_type == 48">
                            <b-col class="text-center">
                              <b-form-checkbox
                                class="mb-2"
                                id="chkCreate"
                                v-model="user.create"
                                name="chkCreate"
                                value="1"
                                unchecked-value="0"
                                :disabled="disabled"
                              >Crear</b-form-checkbox>
                            </b-col>

                            <b-col class="text-center">
                              <b-form-checkbox
                                class="mb-2"
                                id="chkUpdate"
                                v-model="user.update"
                                name="chkUpdate"
                                value="1"
                                unchecked-value="0"
                                :disabled="disabled"
                              >Editar</b-form-checkbox>
                            </b-col>

                            <b-col class="text-center">
                              <b-form-checkbox
                                class="mb-2"
                                id="chkDelete"
                                v-model="user.delete"
                                name="chkDelete"
                                value="1"
                                unchecked-value="0"
                                :disabled="disabled"
                              >Eliminar</b-form-checkbox>
                            </b-col>

                            <b-col class="text-center">
                              <b-form-checkbox
                                class="mb-2"
                                id="chkRead"
                                v-model="user.read"
                                name="chkRead"
                                value="1"
                                unchecked-value="0"
                                :disabled="disabled"
                              >Leer</b-form-checkbox>
                            </b-col>

                          </b-row>


                        </b-card-body>
                      </b-collapse>
                    </b-card>
                  </div>

                  <b-row v-if="!disabled" class="mt-2">
                    <b-col sm="4" class="center-block">
                      <b-button
                        type="submit"
                        variant="success"
                        class="btn-sm col-sm-12"
                        :disabled="disabled"
                      >Guardar</b-button>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- FIN MODAL PARA LOS CONRATOS -->
  </div>
</template>

<script>
export default {
  name: "users",
  props: {
    caption: {
      type: String,
      default: "Usuarios",
    },
    hover: {
      type: Boolean,
      default: true,
    },
    striped: {
      type: Boolean,
      default: true,
    },
    bordered: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: true,
    },
    fixed: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      token: localStorage.getItem("token"),
      isAdmin: localStorage.getItem("auth_is_admin") === "S" ? true : false,
      items: [],
      fields: [
        {
          key: "selected",
          name: "Selected",
          label: "",
          class: "options-column",
        },
        { key: "status", label: "Estado" },
        { key: "customer_name", label: "Empresa" },
        { key: "name", label: "Usuario" },
        { key: "email", label: "E-Mail" },
        { key: "role_name", label: "Rol" },
        { key: "actions", label: "Opciones" },
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      successModal: false,
      filter: null,
      //
      lstRole: [],
      lstTypeUser: [],
      lstType: [],
      user: {},
      passwordConfirm: null,
      datos: [],
      errores: [],
      selectItems: [],
      selectAll: false,
      status: null,
      rowCount: -1,

      // PARA EL STAFF
      lstTipoDocumento: [],
      lstUsers: [],
      lstType: [],
      lstBranchOffices: [],

      //NUEVO

      isEdit: false,
      table: "customers",
      disabled: false,
      customer_id: null,
      file: null,
      image: null,

      // FILTRO
      role_id_filter: null,
      status_filter: null,
      identification_filter: null,
      // ------------------------------------------------------------------------
      // VARIABLES PARA LA GESTÓN DE LAS ACCIONES Y PERMISOS DE CADA USUARIO
      // ------------------------------------------------------------------------
      CREATE: false,
      READ: false,
      UPDATE: false,
      DELETE: false,
    };
  },
  mounted() {
    this.enabledActions();
    //ROLES DEL SISTEMAS
    this.$http.get(`${this.$urlApi}roles?token=${this.token}`).then(
      (response) => {
        this.lstRole = response.data.data;
      },
      (error) => {
        console.log(error);
        alert(error.body.message);
      }
    );

    this.getUsers();
  },
  computed: {},
  methods: {
    enabledActions() {
      var auth = localStorage.getItem("auth");
      auth = JSON.parse(auth)[0];
      this.CREATE = auth.create == 1;
      this.READ   = auth.read == 1;
      this.UPDATE = auth.update == 1;
      this.DELETE = auth.delete == 1;
    },
    getUsers() {
      showLoader();
      // debugger;
      this.identification_filter = this.identification_filter == "" || this.identification_filter == undefined ? null : this.identification_filter;
      this.$http
        .get(
          `${this.$urlApi}users/${this.role_id_filter}/${this.status_filter}/${this.identification_filter}?token=${this.token}`
        )
        .then(
          (response) => {
            this.items = response.data.data;
            console.log(response);
            hideLoader();
          },
          (error) => {
            console.log(error);
            hideLoader();
          }
        );
    },
    getRowCount(items) {
      return items.length;
    },
    getBadge(status) {
      return getBadge(status);
    },
    getTextStatus(status) {
      return getTextStatus(status);
    },
    initParameters() {
      this.user = {
        password: null,
        role_id: null,
        status: "P",
        user_type: 48, // 48: FUNCIONARIO, 49: CLIENTE
        // DATOS PARA EL STAFF
        name: null,
        last_name: null,
        identification_type: null,
        identification: null,
        phone: null,
        mobile: null,
        personal_mail: null,
        business_mail: null,
        address: null,
        is_boss: null,
        signature: null,
        customer_id: null,
        type: null,
        image: null,
        // SUCURSAL
        branch_office_id: null,
        // PERMISOS
        create: 0,
        update: 0,
        delete: 0,
        read: 0,

        // PARA LA BUSQUEDA DE LA CUENTA
        customer_id: null,
        customer_identification_type: null,
        customer_identification: null,
        customer_name: null,
      };

      this.passwordConfirm = "";
      this.image = null;

      //12: TIPOS DE USUARIOS
      this.$http.get(`${this.$urlApi}parameters/12?token=${this.token}`).then(
        (response) => {
          this.lstTypeUser = response.data.data;
        },
        (error) => {
          console.log(error);
          alert(error.body.message);
        }
      );

      // LISTADO DE TIPOS DE DOCUMENTO
      this.$http.get(`${this.$urlApi}parameters/2?token=${this.token}`).then(
        (response) => {
          this.lstTipoDocumento = response.data.data;
        },
        (error) => {
          console.log(error);
        }
      );

      // LISTADO DE TIPOS DE STAFF
      this.$http.get(`${this.$urlApi}parameters/10?token=${this.token}`).then(
        (response) => {
          this.lstType = response.data.data;
        },
        (error) => {
          console.log(error);
        }
      );

      // SUCURSALES
      this.$http.get(`${this.$urlApi}branch_offices?token=${this.token}`).then(
        (response) => {
          this.lstBranchOffices = response.data.data;
        },
        (error) => {
          console.log(error);
        }
      );

    },
    addUser() {
      showLoader();
      this.initParameters();
      this.errores = [];
      $("#dlgUsuario").modal({ backdrop: "static", keyboard: false }); // EVITA QUE SE CIERRE EL MODAL AL DAR CLIC FUERA DE EL
      this.isEdit = false;
      this.file = null;
      hideLoader();
    },
    editUser(id) {
      showLoader();
      this.initParameters();
      this.errores = [];
      $("#dlgUsuario").modal({ backdrop: "static", keyboard: false }); // EVITA QUE SE CIERRE EL MODAL AL DAR CLIC FUERA DE EL

      this.$http.get(`${this.$urlApi}users/${id}?token=${this.token}`).then(
        (response) => {
          console.log("-----------------------------------------------------------> user ", response.data.data);
          this.user = response.data.data;
          this.image = response.data.data.image;
          hideLoader();
        },
        (error) => {
          console.log(error);
          hideLoader();
        }
      );

      this.file = null;
      this.isEdit = true;
      $("#dlgUsuario").modal("show");
    },
    deleteUser(id) {
      this.$swal({
        title: "Eliminar",
        text: "Desea eliminar el registro!",
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        confirmButtonText: "Aceptar",
      }).then((result) => {
        if (result.value) {
          showLoader();
          this.$http
            .delete(`${this.$urlApi}users/${id}?token=${this.token}`, {
              headers: { "Content-Type": "application/json" },
            })
            .then(function (response) {
              hideLoader();

              this.$swal({
                title: "Buen trabajo",
                text: "Registro eliminado correctamente!",
                type: "success",
                showCancelButton: false,
                confirmButtonText: "Aceptar",
              }).then((result) => {
                if (result.value) {
                  this.getUsers();
                }
              });
            })
            .catch((error) => {
              console.log(error);
              hideLoader();
            });
        }
      });
    },
    view(id) {
      showLoader();
      this.initParameters();
      $("#dlgUsuario").modal({ backdrop: "static", keyboard: false }); // EVITA QUE SE CIERRE EL MODAL AL DAR CLIC FUERA DE EL
      this.$http.get(`${this.$urlApi}users/${id}?token=${this.token}`).then(
        (response) => {
          this.user = response.data.data;
          this.image = response.data.data.image;
          hideLoader();
        },
        (error) => {
          console.log(error);
          hideLoader();
        }
      );
      this.disabled = true;
      $("#dlgUsuario").modal("show");
    },
    save() {
      if (this.isEdit) {
        this.update();
      } else {
        this.create();
      }
    },
    create() {
      showLoader();
      if (!this.validateForm()) {
        hideLoader();
        return false;
      }

      this.user.image = this.image;
      this.datos = JSON.stringify(this.user);
      console.log(this.user);
      this.$http
        .post(`${this.$urlApi}users?token=${this.token}`, this.datos, {
          headers: { "Content-Type": "application/json" },
        })
        .then(function (response) {
          console.log(response);
          hideLoader();
          this.$swal({
            title: "Buen trabajo",
            text: "Registro guardado correctamente!",
            type: "success",
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          }).then((result) => {
            if (result.value) {
              this.getUsers();
              $("#dlgUsuario").modal("hide");
            }
          });
        })
        .catch((error) => {
          this.errores = getMsgError(error);
          console.log(error);
          hideLoader();
        });
    },
    update() {
      if (!this.validateForm()) {
        hideLoader();
        return false;
      }

      showLoader();
      let id = this.user.id;
      this.user.image = this.image;
      this.datos = JSON.stringify(this.user);
      console.log(this.user);
      this.$http
        .put(`${this.$urlApi}users/${id}?token=${this.token}`, this.datos, {
          headers: { "Content-Type": "application/json" },
        })
        .then(function (response) {
          console.log(response);
          hideLoader();

          this.$swal({
            title: "Buen trabajo",
            text: "Registro actualizado correctamente!",
            type: "success",
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          }).then((result) => {
            if (result.value) {
              this.getUsers();
              $("#dlgUsuario").modal("hide");
            }
          });
        })
        .catch((error) => {
          this.errores = getMsgError(error);
          hideLoader();
        });
    },
    validateForm: function () {
      this.errores = [];

      // VALIDAR EL EMAIL
      if (!validEmail(this.user.personal_mail)) {
        this.errores.push("Ingrese un E-Mail valido.");
      }

      // VALIDAR LAS CONTRASEÑAS
      if (!this.isEdit) {
        if (this.user.password != this.passwordConfirm) {
          this.errores.push("Las contraseñas no coinciden!");
        } else {
          if (!validatePassword(this.user.password)) {
            this.errores.push(
              "La contraseña es debil, debe contener 8 caracteres, como: letra mayuscula, letra minúscula, número y carácter especial!"
            );
          }
        }
      }
      return this.errores.length === 0;
    },
    close() {
      this.isEdit = false;
      this.disabled = false;
      $("#dlgUsuario").modal("hide");
    },
    onImageChange_(e) {
      console.log(e.target.files[0]);
      this.file = e.target.files[0];
    },

    onImageChange(e) {
      this.file = e.target.files[0];
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
    },
    createImage(file) {
      let reader = new FileReader();
      reader.onload = (e) => {
        this.image = e.target.result;
      };
      reader.readAsDataURL(file);
    },

    selectRow(item) {
      if (!item.selected) {
        if (this.selectAll) {
          this.selectAll = false;
        }
        var index = this.selectItems.indexOf(item);
        if (index > -1) {
          this.selectItems.splice(index, 1);
        }
      } else {
        this.selectItems.push(item);
      }
    },
    toggleSelectAll() {
      if (this.selectAll) {
        for (var i = 0; i < this.items.length; i++) {
          var updatingItem = this.items[i];
          updatingItem.selected = true;
          this.$set(this.items, i, updatingItem);
          this.selectItems.push(updatingItem);
        }
      } else {
        for (var i = 0; i < this.items.length; i++) {
          var updatingItem = this.items[i];
          updatingItem.selected = false;
          this.$set(this.items, i, updatingItem);
        }
        this.selectItems = [];
      }
    },
    actualizarEstado() {
      showLoader();

      let registrosActualizados = 0;

      for (var i = 0; i < this.items.length; i++) {
        var item = this.items[i];
        if (item.selected) {
          item.status = this.status;
          let id = item.id;
          let datos = JSON.stringify(item);

          this.$http
            .put(
              `${this.$urlApi}users/changestatus/${id}?token=${this.token}`,
              datos,
              {
                headers: { "Content-Type": "application/json" },
              }
            )
            .then(function (response) {})
            .catch((error) => {
              console.log(error);
            });
          registrosActualizados = registrosActualizados + 1;
        }
      }

      if (registrosActualizados > 0) {
        hideLoader();
        this.$swal({
          title: "Buen trabajo",
          text: "Estados actualizados correctamente!",
          type: "success",
          showCancelButton: false,
          confirmButtonText: "Aceptar",
        }).then((result) => {
          if (result.value) {
            this.getUsers();
            this.status = null;
            this.selectItems = [];
          }
        });
      }
    },
    eliminarSeleccionados() {
      this.$swal({
        title: "Eliminar",
        text: "Desea eliminar las cuentas seleccionadas!",
        type: "question",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        confirmButtonText: "Aceptar",
      }).then((result) => {
        if (result.value) {
          for (var i = 0; i < this.items.length; i++) {
            var updatingItem = this.items[i];
            if (updatingItem.selected) {
              let id = updatingItem.id;
              this.$http
                .delete(`${this.$urlApi}users/${id}?token=${this.token}`, {
                  headers: { "Content-Type": "application/json" },
                })
                .then(function (response) {})
                .catch((error) => {
                  console.log(error);
                });
            }
          }

          this.$swal({
            title: "Buen trabajo",
            text: "Registros eliminados correctamente!",
            type: "success",
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          }).then((result) => {
            if (result.value) {
              this.getUsers();
              this.rowCount = 0;
              this.selectItems = [];
            }
          });
        }
      });
    },
    getCustomer() {
      if (
        this.user.customer_identification_type !== null &&
        this.user.customer_identification !== null
      ) {
        showLoader();
        this.$http
          .get(
            `${this.$urlApi}customers/identification/${this.user.customer_identification_type}/${this.user.customer_identification}?token=${this.token}`
          )
          .then(
            (response) => {
              if (response.data.success == true) {
                this.user.customer_id = response.data.data.id;
                this.user.customer_name = response.data.data.business_name;
              } else {
                this.$swal({
                  title: "Información",
                  text: "No se encontró la cuenta!",
                  type: "info",
                  showCancelButton: false,
                  confirmButtonText: "Aceptar",
                });
              }

              hideLoader();
            },
            (error) => {
              console.log(error);
              this.errores = getMsgError(error);
              hideLoader();
            }
          );
      }
    },
  },
};
</script>
